interface SenderColor {
  accent: string;
  avatarBg: string;
  avatarFg: string;
}

const PALETTE: SenderColor[] = [
  { accent: '#EA580C', avatarBg: '#EA580C', avatarFg: '#fff' }, // orange
  { accent: '#0D9488', avatarBg: '#0D9488', avatarFg: '#fff' }, // teal
  { accent: '#DB2777', avatarBg: '#DB2777', avatarFg: '#fff' }, // magenta
  { accent: '#D97706', avatarBg: '#D97706', avatarFg: '#fff' }, // amber
  { accent: '#4338CA', avatarBg: '#4338CA', avatarFg: '#fff' }, // indigo
  { accent: '#E11D48', avatarBg: '#E11D48', avatarFg: '#fff' }, // rose
  { accent: '#059669', avatarBg: '#059669', avatarFg: '#fff' }, // emerald
  { accent: '#475569', avatarBg: '#475569', avatarFg: '#fff' }, // slate
];

const cache = new Map<string, SenderColor>();

function djb2(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return hash >>> 0;
}

export function getSenderColor(senderId: string): SenderColor {
  if (cache.has(senderId)) return cache.get(senderId)!;
  const color = PALETTE[djb2(senderId) % PALETTE.length];
  cache.set(senderId, color);
  return color;
}
